import { useQuery } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';

import { PublicationNewAliasRequest } from '@/module/Author/Publication/model/PublicationTypes';
import { useTranslationAddNewAlias } from '@/module/Author/Translation/model/TranslationQuery';
import { translationMembershipOptions } from '@/module/Nomen/TranslationMembership/model/TranslationMembershipModel';

import { Id, useAppNotification } from '@feature/utils';

import { PublicationSearchClaimable } from '../Publication/PublicationSearchClaimable';

export function TranslationSearchClaimable() {
  const notification = useAppNotification();
  const navigate = useNavigate();

  const { data: memberships, isLoading, isError } = useQuery(translationMembershipOptions.getAll());

  const mutation = useTranslationAddNewAlias();
  const onAddNewAlias = (publicationId: Id, request: PublicationNewAliasRequest) =>
    mutation.mutate(
      { translationId: publicationId, request: request },
      {
        onSuccess: translation => {
          notification.success();
          navigate({ to: '/author/translation/$translationId', params: { translationId: String(translation.id) } });
        },
        onError: notification.error,
      },
    );

  return (
    <PublicationSearchClaimable
      memberships={memberships}
      membershipsLoading={isLoading}
      membershipsError={isError}
      onAddNewAlias={onAddNewAlias}
    />
  );
}
